import React from "react";
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner'
import useApi from "../../../lib/apiService";
import { useDealerContext } from "../DealerContext.jsx";

function VinLookup(props) {
    const Api = useApi();
    const [showLookup, setShowLookup] = React.useState(false);
    const [showSpinner, setShowSpinner] = React.useState(false);
    const [vinInput, setVinInput] = React.useState(""); 
    const [vin, setVin] = React.useState(null);
    const [vehicleData, setVehicleData] = React.useState(null);
    const [entityLookupResults, setEntityLookupResults] = React.useState({});
    const context = useDealerContext();
    
    React.useEffect(() => {
      (async() => {
        if (vin) {
          setVehicleData(null);
          setShowSpinner(true);
          try {
            // Search CVI 1.0 and CVI 2.1 in parallel — they are separate systems, so one
            // failing (or not knowing the VIN) must not discard the other's results.
            const sources = ["CVI 1.0", "CVI 2.1"];
            const settled = await Promise.allSettled([
              Api.getCviVehiclesForVin(vin),
              Api.getCvi2VehiclesForVin(vin),
            ]);
            const result = [];
            const failures = [];
            settled.forEach((outcome, i) => {
              if (outcome.status === "fulfilled") {
                result.push(...(outcome.value ?? []));
              } else {
                console.error(`Error searching ${sources[i]} for VIN ${vin}:`, outcome.reason);
                failures.push(sources[i]);
              }
            });

            if (result.length > 0) {
              if (failures.length > 0) {
                alert(`Could not search ${failures.join(", ")} — showing results from the remaining system(s).`);
              }
              let entities = {};
              for (let v in result) {
                entities[result[v].entityId] = null;
              }
              setEntityLookupResults(entities);
              setVehicleData(result);
            } else if (failures.length > 0) {
              alert(`VIN not found, and ${failures.join(", ")} could not be searched.`);
            } else {
              alert("VIN not found");
            }
          } catch (e) {
            alert(e);
          }
          setShowSpinner(false);
        }
      })();
    }, [vin]);

    React.useEffect(() => {
      async function loadEntityName(id) {
        try {
          // Try EWS first
          let ewsDealer = await Api.ewsLookup(id);
          if (ewsDealer) {
            let x = { ...entityLookupResults };
            x[id] = ewsDealer.name;
            setEntityLookupResults(x);
            return;
          }
          
          // If EWS fails, try CORG
          let corgDealer = await Api.corgLookup(id);
          if (corgDealer) {
            let x = { ...entityLookupResults };
            x[id] = corgDealer.legalName;
            setEntityLookupResults(x);
            return;
          }
          
          console.log("Error getting entity names - not found in EWS or CORG");
        } catch(e) {
          console.error("Error getting entity name:", e);
        }
      }
  
      function getKeyByValue(object, value) {
        return Object.keys(object).find(key => object[key] === value);
      }
  
      //console.log(entityLookupResults);
      // get entity name for next id with null value
      let eid = getKeyByValue(entityLookupResults, null);
      if (eid) {
        loadEntityName(eid);
      }
  
    }, [entityLookupResults]);

    const handleSearch = (e) => {
      if (e) e.preventDefault();
      setVin(vinInput);
    }

    let entityName = (id) => {
      if (entityLookupResults[id] === null || entityLookupResults[id] === undefined) {
        return <Spinner animation="border" size="sm" />;
      } else {
        return entityLookupResults[id];
      }
    };  

    const loadVehicle = (v) => {
      setShowLookup(false);
      context.setDealer(v.entityId, { vin });
    }

    return <>
    <Button variant="outline-secondary" size="sm" className="me-2" onClick={() => setShowLookup(true)} id="vin-lookup-button">VIN Lookup</Button>
    <Modal centered size="lg" show={showLookup} onHide={() => setShowLookup(false)}>
    <Modal.Header closeButton>
      <Modal.Title>VIN Lookup Tool</Modal.Title>
    </Modal.Header>
    <Modal.Body>

    VIN <input type="text" placeholder="" size="34" value={vinInput} 
      onKeyDown={(e) => {if (e.key === "Enter") handleSearch();}}
      onChange={(e) => setVinInput(e.target.value)} id="vin-search-input"></input>
    <Button onClick={handleSearch} id="vin-search-button">Search</Button>

    <div style={{margin: "8px"}}>
    {showSpinner && <Spinner animation="border" />}
    <table width={"100%"}>
    <tbody>
      <tr>
        <th>EntityId</th>
        <th>Dealer Name</th>
        <th>Source System</th>
        <th>VIN Type</th>
        <th>VIN Status</th>
      </tr>

      {vehicleData && vehicleData.map(v => <tr key={`${v.sourceSystem}-${v.id}`}>
        <td><Button variant="link" onClick={() => loadVehicle(v)}>{v.entityId}</Button></td>
        <td>{entityName(v.entityId)}</td>
        <td>{v.sourceSystem}</td>
        <td>{v.type}</td>
        <td>{v.purchaseStatus}</td>
      </tr>)}
    </tbody>
    </table>    
    </div>

    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={() => setShowLookup(false)}>Close</Button>
    </Modal.Footer>
  </Modal>
  </>
}

export default VinLookup;
